import {inject, observer} from 'mobx-react';
import LazyImg from 'components/LazyImg';
import './index.scss';
@inject(({store}) => ({
    syggpz: store.syggpz,
    jump: store.jump
}))
@observer
class AdArea extends React.Component {
    render() {
        const {floorId, syggpz, jump} = this.props;
        if(!floorId) return null;

        let data = {};
        syggpz.some(item => {
            if(item.position === floorId) {
                data = item;
                return true;
            }
            return false;
        });
        if(!data.position) return null;

        const {img, jumpInfo} = data.cards[0];
        return (
            <LazyImg scrollContainer="#container">
                <div className="m-ad-area">
                    <div className="m-ad-img" onClick={()=> !!jumpInfo && jump(jumpInfo)}>
                        <img src={img} />
                    </div>
                </div>
            </LazyImg>
        );
    }
}

export default AdArea;